export default {
  sections: {
    settings: 'Indstillinger',
  },
  status_switch: {
    label: 'Loyalitetsprogram',
    on: 'Til',
    off: 'Fra',
    description: 'Kunder optjener cashback på hver ordre og kan indløse den ved betaling.',
    description_missing: 'Gem indstillingerne nedenfor for at starte dit loyalitetsprogram.',
  },
  alerts: {
    off: 'Dit loyalitetsprogram er slået fra. Kunder optjener ikke cashback på nye ordrer, kan ikke indløse deres point og ser ikke programmet i din butik. Point de allerede har optjent, bevares og udløber som normalt.',
    expired: 'Dit loyalitetsprogram er afsluttet. Slå det til for at genstarte det uden slutdato.',
  },
  form: {
    title: {
      label: 'Titel',
    },
    percentage: {
      label: 'Cashback-procent',
      validation: {
        required: 'Cashback-procent er påkrævet',
        min: 'Minimumsværdien for cashback-procent er {{value}} %',
        max: 'Maksimumsværdien for cashback-procent er {{value}} %',
      },
    },
    point_lifetime: {
      label: 'Hvor mange dage vil du give dine kunder til at bruge point?',
      validation: {
        min: 'Minimum {{value}} dage til udløb af point',
      },
    },
    min_spending_limit: {
      label: 'Minimumsgrænse for forbrug til cashback',
      validation: {
        required: 'Minimumsgrænse for forbrug er påkrævet',
        gt_zero: 'Minimumsgrænse for forbrug skal være større end 0',
        lt_max_spending_limit: 'Minimumsgrænse for forbrug skal være lavere end maksimumsgrænsen',
      },
    },
    max_spending_limit: {
      label: 'Maksimumsgrænse for forbrug til cashback',
      validation: {
        required: 'Maksimumsgrænse for forbrug er påkrævet',
        gt_min_spending_limit: 'Maksimumsgrænse for forbrug skal være højere end minimumsgrænsen',
      },
    },
    has_welcome_bonus: {
      label: 'Velkomstbonus',
      description: 'Giv dine nye kunder en cashback-bonus ved tilmelding',
    },
    welcome_bonus: {
      label: 'Værdi af velkomstbonus',
    },
    has_end_date: {
      label: 'Varighed',
      options: {
        false: 'Ubegrænset',
        true: 'Med bestemt slutdato',
      },
    },
    end_date: {
      label: 'Slutdato',
    },
    has_mobile_app_signup_bonus: {
      label: 'Tilmeldingsbonus i mobilappen',
      description: 'Beløn brugere, der logger ind via mobilappen for første gang',
    },
    mobile_app_signup_bonus: {
      label: 'Bonusbeløb',
    },
  },
  tags: {
    inactive: 'Ikke aktiv',
    active: 'Aktiv',
    expired: 'Udløbet',
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    changes_got_saved: 'Ændringerne er gemt',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    turned_on: 'Loyalitetsprogram slået til',
    turned_off: 'Loyalitetsprogram slået fra',
  },
};
